let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6HpCe")).then(() => parcelRequire('hBeZB'));